var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertBlueIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "21px",
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Safety/SafetyAlert/32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_Health_No_Alert_03",
    transform: "translate(-342.000000, -267.500000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Safety/SafetyAlert/32",
    transform: "translate(342.000000, 267.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C12.4784206,0 12.9205565,0.252677334 13.157079,0.66145899 L23.824783,19.0367897 C24.0599616,19.4429255 24.0586178,19.9416656 23.8194075,20.3464785 C23.5801972,20.7512914 23.1420929,21 22.6663601,21 L1.3336399,21 C0.857907074,21 0.419802829,20.7512914 0.180592536,20.3464785 C-0.0586177572,19.9416656 -0.0599616353,19.4429255 0.175217024,19.0367897 L10.842921,0.66145899 C11.0794435,0.252677334 11.5215794,0 12,0 Z M12,1.31233464 L1.3336399,19.6876654 L22.6663601,19.6876654 L12,1.31233464 Z M12.0002688,15.75 C12.7367139,15.75 13.3333958,16.3373756 13.3333958,17.0623346 C13.3333958,17.7872937 12.7367139,18.3746693 12.0002688,18.3746693 C11.2638236,18.3746693 10.6671417,17.7872937 10.6671417,17.0623346 C10.6671417,16.3373756 11.2638236,15.75 12.0002688,15.75 Z M13.0116714,6.56246693 L13.0116714,7.22789467 C13.0116714,8.47408341 12.7254254,12.8423586 12.5735672,14.4377977 L11.4594922,14.4377977 C11.3089779,12.8423586 11.021388,8.47408341 11.021388,7.22789467 L11.021388,6.56246693 L13.0116714,6.56246693 Z",
    id: "SafetyAlert"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBlueIcon);
export default __webpack_public_path__ + "static/media/alert-blue-icon.748836d6ce9c49f19c238ad8e6ae1adb.svg";
export { ForwardRef as ReactComponent };